import { Action } from '@canvas/model/permissions';

import { policyAction, type PersistentPolicy } from '../../policy-manager-types';

export const canAddCommentPolicy: PersistentPolicy = {
  id: 'can-add-comment',
  type: 'persistent',
  rule: (state) => {
    const canComment = policyAction(Action['add/comment']);
    if (state.has(canComment)) {
      return { can: canComment };
    }
    return { cannot: canComment };
  },
};
